export default __webpack_public_path__ + "static/media/face_2_47.6278230a.png";